export const environment = {
  production: false,
  // rootUrlApi: 'http://api-toobook.com/api/'
  // rootUrlApi: 'http://api-toobook.local/api/'
  rootUrlApi: 'https://homologacao.toobook.com.br/api/'
};
